/**
 * Items model to group all apis related to it
 *
 *
 * To seperate all logic
 *
 */

import React, { useState, useEffect, useContext, useRef } from 'react';

import Model from './models';

import { ApiUtils } from 'soxo-bootstrap-core';

class Items extends Model {
    constructor() {
        super();

        this.title = 'Reporting List';

        this.fields = [
            {
                field: 'name',
                caption: 'Name',
            },
            {
                field: 'amount',
                caption: 'Amount',
            },
        ];

        // this.columns = ;
    }

    get id() {
        return 'cold_id';
    }

    get getEndpoint() {
        return 'item';
    }

    get path() {
        return `collections`;
    }

    get getName() {
        return this.modelName + `s`;
    }

    get modelName() {
        return `collection`;
    }

    get columns() {
        return [
            {
                caption: 'Staff',
                field: 'staff.name',
                key: 'staff',
            },
            {
                caption: 'Weight',
                field: 'weight',
                key: 'weight',
            },
            {
                caption: 'Date',
                field: 'created_at',
                key: 'created_at',
            },
        ];
    }

    /**
     * Get all the packages
     *
     * @returns
     */
    getPackages = () => {
        return ApiUtils.get({
            url: `item?page=1&limit=50&itm_package=OP`,
        });
    };
    /**
     * 
     * @param {*} record 
     * @returns 
     */
    getItemRateMapping = (record) => {
        return ApiUtils.get({
            url: `item/itemrate-mapping?type=${record.type}&corporate_pointer=${record.corporate_pointer}&package_value=${record.package_value}`,
        });
    };

    /**
     * 
     * @param {*} record 
     * @returns 
     */
    getCorporateReferrerMapping = (code) => {
        return ApiUtils.get({
            url: `corporatereferrermapping/get-referrer/${code}`,
        });
    };

    /**
     * Get all the packages
     *
     * @returns
     */
    getDoctorsList = () => {
        return ApiUtils.get({
            url: `doctor?do_type=DROTR&do_active=Y`,
        });
    };
      /**
     * 
     * @param {*} record 
     * @returns 
     */
      getItemRateMapping = (formBody) => {

        return ApiUtils.post({
            // url: `item/itemrate-mapping?type=${record.type}&corporate_pointer=${record.corporate_pointer}&package_value=${record.package_value}`
            url: `item/itemrate-mapping`,
            formBody
            ,
        });
    };

    /**
     *
     * @returns Get Genei\ric List
     */
    getReasonsList = () => {
        return ApiUtils.get({
            url: `Generallist?genl_mode=OPRSN&genl_active=Y&limit=200`,
        });
    };

    /**
     *
     * For stoptb
     * Get all the items
     */
    getItemByCategory = (id, category = 'GEN') => {
        return ApiUtils.get({
            url: `item/itemWithRate?itm_code=${id}&category=${category}`,
        });
    };

    /**
     * Get all the items
     */
    getItems = (id) => {
        return ApiUtils.get({
            url: `item/withRate/${id}`,
        });
    };

    /**
     * Get all the items
     */
    getItemsForT = (id) => {
        return ApiUtils.get({
            url: `item`,
        });
    };

    /**
     * Get all the items
     */
    getItemsWithCategory = (id) => {
        return ApiUtils.get({
            url: `item/itemWithCategory`,
        });
    };
}

export default Items;
